export { type LoaderConfig, type ParseResult, loadGLTF } from '@qunhe/egs-gltf-loader';
